import { render } from "./clientstable.vue?vue&type=template&id=19da63c9&scoped=true"
import script from "./clientstable.vue?vue&type=script&lang=js"
export * from "./clientstable.vue?vue&type=script&lang=js"

import "./clientstable.vue?vue&type=style&index=0&id=19da63c9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19da63c9"]])

export default __exports__